import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import HeaderWrapper from "./Header/HeaderWrapper";
import TextMainBannerWrapper from "./TextMainBanners/TextMainBannerWrapper";
import FooterWrapper from "./Footer/FooterWrapper";
import { SendPostRequest } from "../http";

function ForgetPassword() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const sitedata = useSelector((store) => store.global.loginData);

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!newPassword) return toast.error("Enter New Password");
    if (!confirmPassword) return toast.error("Confirm Password");
    if (newPassword !== confirmPassword)
      return toast.error("Password doesn't match");

    try {
      await SendPostRequest("auth/forget_password", {
        action: "change_password",
        verify_code: slug,
        new_password: newPassword,
      });

      toast.success("Password has been changed successfully");
      navigate("/login");
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  return (
    <div className="page-wrapper-inner">
      <ToastContainer />
      <HeaderWrapper />
      <TextMainBannerWrapper
        Heading="Reset Password"
        Image="theme-2-banner-login.webp"
      />

      <div className="content-wrapper pad-none">
        <div className="content-inner">
          {sitedata?.theme_login_form === "colored" ? (
            /* ===== COLORED THEME ===== */
            <section className="py-5" style={{ background: "#000" }}>
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-6 col-md-8">
                    <form className="login-colored-bd pad-40">
                      <h3 className="title mb-4 text-white text-center">
                        Reset Your Password
                      </h3>

                      <input
                        type="password"
                        className="form-control mb-3"
                        placeholder="New Password"
                        onChange={(e) => setNewPassword(e.target.value)}
                      />

                      <input
                        type="password"
                        className="form-control mb-3"
                        placeholder="Confirm Password"
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />

                      <button
                        className="btn login-colored-btn w-100 mt-2"
                        onClick={handleSubmit}
                      >
                        Change Password
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </section>
          ) : (
            /* ===== SIMPLE THEME ===== */
            <section className="pad-top-5 pt-5 pb-5">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-6 col-md-8">
                    <form className="bg-grey pad-40">
                      <h3 className="title mb-4 text-center">
                        Reset Your Password
                      </h3>

                      <input
                        type="password"
                        className="form-control mb-3"
                        placeholder="New Password"
                        onChange={(e) => setNewPassword(e.target.value)}
                      />

                      <input
                        type="password"
                        className="form-control mb-3"
                        placeholder="Confirm Password"
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />

                      <button
                        className="btn btn-default w-100"
                        onClick={handleSubmit}
                      >
                        Change Password
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </section>
          )}
        </div>
      </div>

      <FooterWrapper />
    </div>
  );
}

export default ForgetPassword;
